const uzFooter = {
    address:"Manzil",
    fulladress:"Toshkent sh. Chilonzor t. Zargarlik k. Qizil sharq 32.",
    link:"Tezkor havolalar"
   
}
export default uzFooter;  